export default __webpack_public_path__ + "50d851d8cc01a32500cd02966867ac63.avif";